module.exports = __webpack_public_path__ + "img/good.5fd3630f.png";